import { useGoals } from 'features/goals';
import { useLocalizedLifeAreas } from 'features/life-areas';
import { useTimeframeTime } from 'features/user';
import React, { useRef, useState } from 'react';
import { GoalContextMenu } from 'shared/components/connected/goal-context-menu';
import { NoMetricCard } from 'shared/components/ui/goal-insights-card';
import { useOpenGoalMetricsForm } from 'shared/contexts/goal-metrics-form';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { useContextMenuState } from 'shared/hooks/use-context-menu-state';
import { useNumberFormat } from 'shared/hooks/use-number-format';
import { useUser } from 'shared/hooks/use-user';
import { Goal } from 'shared/types/goal';
import { getWeekStartsOn } from 'shared/utils/get-week-starts-on';

export type NoMetricInsightsCardProps = {
  goal: Goal;
  hasBigTitle?: boolean;
  isLink?: boolean;
  showLeftAxis?: boolean;
};

export const NoMetricInsightsCard: React.FC<NoMetricInsightsCardProps> = ({
  goal,
  hasBigTitle,
  isLink,
  showLeftAxis,
}) => {
  const menuButtonRef = useRef<HTMLButtonElement>(null);
  const goals = useGoals();
  const lifeAreas = useLocalizedLifeAreas();
  const user = useUser();
  const numberFormat = useNumberFormat();
  const { startDate, endDate } = useTimeframeTime({
    weekEndsWithStartOfDay: true,
  });
  const openPremiumDialog = useOpenPremiumDialog();
  const openGoalMetricsForm = useOpenGoalMetricsForm();

  const [menuButtonUsed, setMenuButtonUsed] = useState(false);
  const {
    open: openMenu,
    close: closeMenu,
    position: menuPosition,
  } = useContextMenuState({
    onClose: () => setMenuButtonUsed(false),
  });

  const openMenuByButton = (e: React.MouseEvent) => {
    setMenuButtonUsed(true);
    openMenu(e);
  };

  const onSelectMetric = () => openGoalMetricsForm(goal);

  return (
    <>
      <NoMetricCard
        goal={goal}
        goals={goals}
        lifeAreas={lifeAreas}
        startDate={startDate}
        endDate={endDate}
        weekStartsOn={getWeekStartsOn(user)}
        numberFormat={numberFormat}
        showLeftAxis={showLeftAxis}
        onSelectMetric={
          goal.frozenAt || goal.archivedAt ? undefined : onSelectMetric
        }
        onPremium={openPremiumDialog}
        onContextMenu={openMenu}
        menuButtonRef={menuButtonRef}
        onMenuButton={openMenuByButton}
        hasBigTitle={hasBigTitle}
        isLink={isLink}
      />
      {!!menuPosition && (
        <GoalContextMenu
          id={goal.id}
          onClose={closeMenu}
          referenceElement={menuButtonUsed ? menuButtonRef : undefined}
          location={menuButtonUsed ? undefined : menuPosition}
        />
      )}
    </>
  );
};
